import React, { useEffect } from 'react'
import { useAuth } from '../context/AuthContext'

const Logout: React.FC = () => {
  const { logout } = useAuth()

  useEffect(() => {
    logout('/login')
  }, [logout])

  return null
}

export default Logout
